import { useState } from 'react'

export const useCopyButton = ({
    onCopyClick,
    value = '',
}: {
    onCopyClick?: () => void
    value?: string
}) => {
    const [copied, setCopied] = useState(false)

    const handleDefaultClick = () => {
        navigator.clipboard.writeText(value)
    }

    const handleCopyClick = () => {
        if (onCopyClick) {
            onCopyClick()
        } else {
            handleDefaultClick()
        }

        setCopied(true)

        setTimeout(() => {
            setCopied(false)
        }, 2000)
    }

    return {
        copied,
        handleCopyClick,
    }
}
